/// <amd-module name="Repos/Common/Util/ChangeCounts" />
import { GitChange, VersionControlChangeType } from "Repos/Common/Contracts/Git";
import * as Resources from "Repos/Common/Resources";
import { format } from "VSS/Core/Util/String";

export function getChangeSummaryText(changes: GitChange[]): string {
    return summarizeChangeTypes(changes.filter(c => !c.item.isFolder).map(c => c.changeType));
}

export function summarizeChangeTypes(changeTypes: VersionControlChangeType[]): string {
    let adds = 0,
        edits = 0,
        renames = 0,
        deletes = 0;

    for (const changeType of changeTypes) {
        if ((changeType & VersionControlChangeType.Add) !== 0) {
            adds++;
        } else if ((changeType & VersionControlChangeType.Edit) !== 0) {
            edits++;
        } else if ((changeType & VersionControlChangeType.Delete) !== 0) {
            deletes++;
        } else if ((changeType & VersionControlChangeType.Rename) !== 0) {
            renames++;
        }
    }

    const total = adds + edits + renames + deletes;

    const fileChanges = format(total === 1 ? Resources.FileSummaryTotalFile : Resources.FileSummaryTotalFiles, total);
    if (total === 0) {
        return fileChanges;
    }

    const changeTexts: string[] = [];
    if (adds > 0) {
        changeTexts.push(format(adds === 1 ? Resources.FileSummaryAddedFile : Resources.FileSummaryAddedFiles, adds));
    }
    if (edits > 0) {
        changeTexts.push(format(edits === 1 ? Resources.FileSummaryEditedFile : Resources.FileSummaryEditedFiles, edits));
    }
    if (renames > 0) {
        changeTexts.push(format(renames === 1 ? Resources.FileSummaryRenamedFile : Resources.FileSummaryRenamedFiles, renames));
    }
    if (deletes > 0) {
        changeTexts.push(format(deletes === 1 ? Resources.FileSummaryDeletedFile : Resources.FileSummaryDeletedFiles, deletes));
    }

    return fileChanges + ": " + changeTexts.join(", ");
}
